module.exports = __webpack_public_path__ + "img/block6-card2.a9de76cb.svg";